import * as React from 'react';

import Routes from 'routing/Routes';
import usePermissions from 'hooks/usePermissions';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

import StepActionButton from './StepActionButton';

type Props = {
  config: EventProcedureStepAPIType['action']['config'];
};

function StepGoToDashboard({ config }: Props) {
  const { parameters, dashboard_id } = config;

  const { isPermitted } = usePermissions();
  const disabled = !isPermitted(`dashboards:read:${dashboard_id}`);

  const queryString = Object.entries(parameters)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  const formattedURL = queryString
    ? `${Routes.VIEWS.VIEWID(dashboard_id)}?${queryString}`
    : Routes.VIEWS.VIEWID(dashboard_id);

  return (
    <StepActionButton
      hint={disabled ? "You don't have access to see this dashboard" : undefined}
      title="Go to Dashboard"
      to={disabled ? null : formattedURL}
      disabled={disabled}
    />
  );
}

export default StepGoToDashboard;
